module.exports = __webpack_public_path__ + "assets/img/gansudanbao.f4f80367.png";